import React, { Component } from "react";


import { Card, CardBody, CardTitle, Col, Container, Row } from "reactstrap";

// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";

import ToolkitProvider from "react-bootstrap-table2-toolkit";
// import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import MultipleDropdownSelect from "../../../components/MultipleDropdownSelect";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getCampaignsList } from "../../../store/campaigns/list/actions";
import RemoteTable from "../../../components/Common/RemoteTable";
import styled from "styled-components";
import ModifiedMetaTags from '../../../components/ModifiedMetaTags/index';

class Campaigns extends Component {
  constructor(props) {
    super(props);

    this.nameFilter = null;

    this.state = {
      page: 1,
      sizePerPage: 10,
      filter_name: [],
      hidden_columns: ["campaign_name"],
    };

    this.searchTimer = null;
  }

  componentDidMount() {
    this.handleChangeColumnHidden(null, "campaign_name", true);

    this.props.getCampaignsList(this.props.data);
  }

  _updateFilterName = (key, data = this.props.data?.results) => {
    this.setState({
      filter_name: data.map((i, index) => ({
        key: `__${i.name}__${index}`,
        text: i.name,
        checked: false,
      })),
    });
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    // if (prevProps.data !== this.props.data) {
    //   this._updateFilterName("created");
    // }
  }

  handleChangeNameVisible = (data, key, checked) => {
    this.nameFilter(data.filter(i => i.checked).map(i => i.text));

    this.setState({
      filter_name: data,
    });
  };

  handleChangeColumnHidden = (_, dataFieldKey, visible) => {
    if (!dataFieldKey) return false;

    const some = this.state.hidden_columns.some(i => i === dataFieldKey);
    if (!visible) {
      if (!some) {
        this.setState(prev => ({
          hidden_columns: [...prev.hidden_columns, dataFieldKey],
        }));
      }
    } else {
      if (some) {
        this.setState(prev => ({
          hidden_columns: prev.hidden_columns.filter(i => i !== dataFieldKey),
        }));
      }
    }
  };

  filter = () => {
    this.nameFilter(["Airi Satou"]);
  };

  isHiddenColumn = dataField => {
    return this.state.hidden_columns.some(i => i === dataField);
  };

  handleTableChange = data => {
    this.props.getCampaignsList(data);
  };

  campaignNameFormatter = (cell, row) => {
    return (
      <CampaignNameLink onClick={e => this.onClickRow(e, row)}>
        {row.campaign_name}
      </CampaignNameLink>
    );
  };

  onClickRow = (e, row) => {
    this.props.history.push(`/campaigns/${row.id}`);
  };

  render() {
    const columns = [
      {
        dataField: "campaign_name",
        text: "Campaign name",
        sort: true,
        hidden: this.isHiddenColumn("campaign_name"),
        formatter: this.campaignNameFormatter,
      },
      {
        dataField: "status",
        text: "Status",
        sort: true,
        hidden: this.isHiddenColumn("status"),
        // filter: textFilter()
      },
      // {
      //   dataField: "client",
      //   text: "Client",
      //   sort: true,
      //   hidden: this.isHiddenColumn("client"),
      //   // filter: textFilter()
      // },
      {
        dataField: "media_buyer",
        text: "Media buyer",
        sort: true,
        hidden: this.isHiddenColumn("media_buyer"),
        // filter: textFilter()
      },
      {
        dataField: "created_at",
        text: "Created",
        sort: true,
        hidden: this.isHiddenColumn("created_at"),
        // filter: textFilter()
      },
      // {
      //   dataField: "position",
      //   text: "Position",
      //   sort: true,
      //   hidden: this.isHiddenColumn("position")
      //   // filter: textFilter()
      // }
      // {
      //   dataField: "name",
      //   text: "Name",
      //   sort: true,
      //   hidden: this.isHiddenColumn("name"),
      //   formatter: cell => cell,
      //   filter: multiSelectFilter({
      //     options: {},
      //     // placeholder: 'My Custom PlaceHolder',  // custom the input placeholder
      //     // className: "my-custom-text-filter", // custom classname on input
      //     // defaultValue: [], // default filtering value
      //     comparator: Comparator.EQ, // default is Comparator.EQ
      //     getFilter: (filter) => {
      //       // qualityFilter was assigned once the component has been mounted.
      //       this.nameFilter = filter;
      //       return filter;
      //     },
      //     style: { display: "none" } // your custom styles on input
      //     // withoutEmptyOption: true,  // hide the default select option
      //     // id: 'id', // assign a unique value for htmlFor attribute, it's useful when you have same dataField across multiple table in one page
      //   })
      // },
    ];

    return (
      <React.Fragment>
        <div className="page-content">
        <ModifiedMetaTags title="Campaigns list | Mobihunter" />

          <Container fluid>
            <Breadcrumbs
              title="Dashboard"
              breadcrumbItem="Campaigns"
              link="/dashboard"
            />

            <Row>
              <Col className="col-12">
                <Card>
                  <CardBody>
                    {/*<button onClick={this.filter}>filter</button>*/}
                    {/*<p className="card-title-desc">*/}
                    {/*  react-bootstrap-table-next plugin has most features enabled by default,*/}
                    {/*  so all you need to do to use it with your own tables is to*/}
                    {/*  call the construction function:{" "}*/}
                    {/*  <code>react-bootstrap-table-next </code>.*/}
                    {/*</p>*/}
                    <RemoteTable
                      onTableChange={this.handleTableChange}
                      columns={columns}
                      data={this.props.data}
                      loading={this.props.loading}
                    >
                      <MultipleDropdownSelect
                        options={columns.map(({ dataField, text, hidden }) => ({
                          key: dataField,
                          text,
                          checked: !hidden,
                        }))}
                        clear={true}
                        search={true}
                        onChange={this.handleChangeColumnHidden}
                      >
                        <i className="bx bx-menu" />
                      </MultipleDropdownSelect>
                    </RemoteTable>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const CampaignNameLink = styled.div`
  transition-duration: 0.1s;
  &:hover {
    color: rgb(85, 110, 230);
    transition-duration: 0.1s;
  }
`;

Campaigns.propTypes = {
  data: PropTypes.any,
  loading: PropTypes.bool,
  getCampaignsList: PropTypes.func,
  history: PropTypes.any,
};

const mapStateToProps = state => ({
  data: state.CampaignsList.data,
  loading: state.CampaignsList.loading,
});

export default connect(mapStateToProps, { getCampaignsList })(Campaigns);
